/**
 * DISTRIBUTOR-ORDERS MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other product modules directly.
 */

import { useNavigate } from "react-router-dom";
import { useSession } from "../../../shared/components/SessionProvider.jsx";
import OrderFlow from "../components/OrderFlow.jsx";

// Distributor Orders module page. Hosts the ported the source app orders grid
// (Orders / Forecast Comparison / Summary tabs), wired to the Supabase session
// + router. Edit access is granted to any account member for now (role-gating
// can layer on later, matching the sales-forecasting port).
export default function DistributorOrders() {
  const { user } = useSession();
  const navigate = useNavigate();
  return <OrderFlow user={user} canEdit={true} onHome={() => navigate("/")} />;
}
